export default "__VITE_ASSET__Dyhz9oSy__"